<template>
  <v-container
  class="overflow-y-auto"
  >
    <v-divider class="mt-12"></v-divider>
    <h2 class="text-center black--text">Busca tus productos</h2>
    <v-divider></v-divider>


     <v-text-field
     append-icon="mdi-magnify"
                v-model="buscar"
                label="Busca Aqui"
                required
    ></v-text-field>


        <v-row  no-gutters>
      <v-col class="pa-1"
        v-for="cate in listafiltrada"  v-bind:key="cate"
        cols="6"
        xs="6"
        sm="4"
        md="3">

        <v-flex class="pa-1">  

                <v-img
                  :src="cate.foto"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  @click="dialog=!dialog,fotos=cate.fotos,hijo=cate"
                >
                 <v-avatar v-if="cate.oferta" color="#F3E22C" size="49">
                    <span class="white--text caption font-weight-black">OFERTA</span>
                  </v-avatar>
                  <v-avatar v-if="cate.nuevo" color="#F3E22C" size="49">
                    <span class="white--text caption font-weight-black">Nuevo</span>
                  </v-avatar>

                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>

                </v-img>

                        <v-card
                         class="mt-3 text-center mx-auto font-weight-black caption pa-1"
                        label="Solo"
                        height="120"
                        max-width="600"
                        solo
                        readonly
                        >

                <span v-if="cate.pdescuento!=0" class="black--text font-weight-bold body-2" >
                    S/.{{cate.pdescuento}}   
                </span>
                <span v-if="cate.pdescuento==0" class="black--text font-weight-bold body-2" >
                    S/.{{cate.pnormal}}   
                </span>
                 <span v-if="cate.pdescuento!=0" class="red--text font-weight-bold body-2" 
                 style="text-decoration:line-through;">
                   <span v-if="cate.pdescuento==0">S/.{{cate.pdescuento}}   </span> 
                </span>
                <span v-if="cate.pdescuento!=0" class="red--text font-weight-bold body-2" 
                 style="text-decoration:line-through;">
                    S/.{{cate.pnormal}}   
                </span>

                  <p
                  class="text-break text-center subtitle-1 black--text font-weight-black mt-1"
                  >{{cate.nombre}}</p>
                 <v-divider class="mt-n5"></v-divider>

                <v-layout  class="mt-n2">
                <v-row
                v-for="color in cate.color" :key="color"
                cols="1"
                xs="1"
                sm="1"
                md="1"> 
                <v-avatar class="mx-auto" :color="color.color" size="20">
                </v-avatar>
                  </v-row>
                </v-layout>

                <v-divider class="mt-1"></v-divider>

                <v-layout class="mt-n2">
                <v-row                
                v-for="tallas in cate.talla" :key="tallas"
                cols="1"
                xs="1"
                sm="1"
                md="1"> 
                <v-avatar class="mx-auto" color="black" size="20" >
                  <span class="white--text caption" >{{tallas.talla}}</span>
                </v-avatar>
                  </v-row>
                  
                  </v-layout>

                    </v-card>
            </v-flex>
  
      </v-col>

    </v-row>
  <v-divider></v-divider>
    <p class="text-center bold font-weight-black headline">NUESTRAS LINEAS DE PRODUCTO</p>
      <v-divider></v-divider>

       <cuerpoprincipal />


    <v-dialog
      v-model="dialog"
      max-width="390"
      >
    <div>
      <v-system-bar window dark>
        <v-icon @click="dialog = false">mdi-close</v-icon>
      </v-system-bar>
    </div>
      <v-card >
             <v-carousel
              class="mx-auto"
              cycle
              interval="5000"
              outlined
              hide-delimiters
              show-arrows
              height="400" 
            >
              <v-carousel-item
                v-for="alc in fotos" :key="alc"
              >
                  <v-row
                    class="fill-height xs-12"
                  >
                 <v-img :src="alc.foto" height="400" 
                  class="white--text align-end"
                  ></v-img>
                  </v-row>
              </v-carousel-item>
            </v-carousel>

        <v-card-actions>
        
          <v-spacer></v-spacer>
              <router-link to="/pormodelo/" >
          <v-btn
            color="green darken-1"
            text
            @click="dialog=false,$store.commit('ingresaHijo',hijo)"
          >
            Agregar a Carrito
          </v-btn>
              </router-link>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { db } from '../db'
import cuerpoprincipal from '@/components/cuerpoprincipal'
import mensajeCard from '@/components/mensajeCard'
import store from '@/store/index'

  export default {
    name: 'pagProductos',
      components: {
        cuerpoprincipal,
        mensajeCard,
  },

      firebase: {
        productosPadre: db.database().ref("productosPadre").orderByChild("orden"),
      },

    data() {
        return {
          productosPadre: [],
          dialog:false,
          fotos:[],
          hijo:[],
          buscar:'',
          data:''
        }
      },

    computed: {
        listafiltrada() {
            return this.productosPadre.filter((item)=> 
            (item.nombre + item.categoria + item.marca + item.descripcion)
            .toLowerCase().includes(this.buscar.toLowerCase()))
        }
            
    },
     mounted() {
            this.buscar= this.$route.params.dato
     },



  }
</script>